import { AnnotationContextType, type ANNAnnotationRecord } from "src/modules/ANNModule/ANNTypes";
import { SERVITUT_NOTE_SAVE_CONCURRENCY, runWithConcurrency } from "./jobs";
import { rowDocumentIds } from "../model/identity";
import { projectAnnOntoRow } from "../model/projectAnn";
import type { ServitutRow } from "../model/row";

export async function listAnnotationsForRow(
   row: ServitutRow,
   organizationId?: string,
): Promise<ANNAnnotationRecord[]> {
   const documentIds = rowDocumentIds(row);
   if (!documentIds.length) {
      return [];
   }
   const records: ANNAnnotationRecord[] = [];
   const seen = new Set<string>();
   try {
      const { ANNManager } = await import("src/modules/ANNModule/ANNManager");
      for (const documentId of documentIds) {
         const listed = await ANNManager.listAnnotations(
            AnnotationContextType.Servitut,
            documentId,
            organizationId,
         );
         listed.forEach((record) => {
            if (record.id && !seen.has(record.id)) {
               seen.add(record.id);
               records.push(record);
            }
         });
      }
      return records;
   } catch (error) {
      console.warn("[Servitutredegørelse] failed to list annotations", row.id, error);
      return records;
   }
}

export async function hydrateRowsFromAnn(
   rows: ServitutRow[],
   organizationId?: string,
   options?: { hasCaseDescription?: boolean },
): Promise<{ rows: ServitutRow[]; records: ANNAnnotationRecord[] }> {
   const records: ANNAnnotationRecord[] = [];
   const seen = new Set<string>();
   const listedById = new Map<string, ANNAnnotationRecord[]>();
   await runWithConcurrency(rows, SERVITUT_NOTE_SAVE_CONCURRENCY, async (row) => {
      listedById.set(row.id, await listAnnotationsForRow(row, organizationId));
   });
   const next = rows.map((row) => {
      const listed = listedById.get(row.id) ?? [];
      listed.forEach((record) => {
         if (record.id && !seen.has(record.id)) {
            seen.add(record.id);
            records.push(record);
         }
      });
      return projectAnnOntoRow(row, listed, { ...options, recordsAreComplete: true });
   });
   return { rows: next, records };
}

export function hydrateRowsFromRecords(
   rows: ServitutRow[],
   records: ANNAnnotationRecord[],
   options?: { hasCaseDescription?: boolean },
): ServitutRow[] {
   return rows.map((row) => projectAnnOntoRow(row, records, options));
}
